<div style="display: flex; width: 90vw; height: 100vh; overflow: hidden; position: relative; z-index:998;">
    <button (click)="fecharModal()" class="fechar">
        <i class="fa-solid fa-x fa-flip-both"></i>
    </button>
    <iframe style="width: 85vw!important; height: 100vh; margin: auto;"
        [src]='link'
        title="Corretor" frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen>
    </iframe>
</div>
